import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowCircleTopComponent } from "./med-icon-arrow-circle-top.component";

@NgModule({
  declarations: [
    MedIconArrowCircleTopComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowCircleTopComponent,
  ],
})
export class MedIconArrowCircleTopModule { }
